module.exports = "/assets/images/578024cbf34d52b2c56527aca0b83b4a.svg";